"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;




















































































































































































































































































var _formatter = require("@/utils/formatter");
var _popProtocolList = _interopRequireDefault(require("./protocol/popProtocolList")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { components: { PopProtocol: _popProtocolList.default }, data: function data() {var _this = this;return { tableData: [], // 列表数据
      shortTemplateData: [], deviceTypeCode: '', templateSelection: '', isDisabl: false, handleShowProtocol: false, codeName: '', codeNum: 0, handleCloseProptocol: function handleCloseProptocol() {_this.handleShowProtocol = false;}, handleOpenProtocol: function handleOpenProtocol() {_this.handleShowProtocol = true;}, searchData: { id: '', templateType: '1', auditStatus: '', deviceTypeCode: '', isEnabled: '1', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, // 表格列
      tableColumns: [// {
      //   prop: 'deviceTypeName',
      //   label: '椅子型号名称',
      //   isShow: true // 是否显示
      // },
      // {
      //   prop: 'deviceTypeCode',
      //   label: '椅子型号编码',
      //   isShow: true // 是否显示
      // },
      // {
      //   prop: 'firmwareVersion',
      //   label: '固件版本号',
      //   isShow: true // 是否显示
      // },
      { prop: 'protocolVersion', label: '模型版本号', isShow: true // 是否显示
      }, { prop: 'auditUserName', label: '封存人', isShow: true // 是否显示
      }, { prop: 'isEnabled', label: '启、禁用', formatter: _formatter.statusFormatter, isShow: true // 是否显示
      }, { prop: 'auditStatus', label: '封存状态', formatter: _formatter.auditStatusFormatter, isShow: true // 是否显示
      }, { prop: 'auditTime', label: '封存时间', sortable: true, formatter: _formatter.dateFormatter, isShow: false // 是否显示
      }, { prop: 'createTime', label: '创建时间', sortable: true, formatter: _formatter.dateFormatter, isShow: true // 是否显示
      }], detailsearchData: { id: '', name: '', code: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, pageData2: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, typeadd: false, newadd2: false, title: '新增', addData: { id: '', templateType: '1', jsonFile: '', deviceTypeCode: '', firmwareVersion: '', referFunctionCodes: [], referProtocolId: '', remark: '', protocolCheck: '', audit: '' }, defaultData: { id: '', jsonFile: '', templateType: '1', deviceTypeCode: '', firmwareVersion: '', referFunctionCodes: [], referProtocolId: '', remark: '', audit: '' }, rules: { firmwareVersion: [{ required: true, message: '请输入固件版本号', trigger: 'blur' }], deviceTypeCode: [{ required: true, message: '请选择椅子型号', trigger: 'blur' }] } };}, filters: { isEnabledfliters: function isEnabledfliters(val) {if (val === 0) {return '启用';} else if (val === 1) {return '禁用';} else {return val;}} }, mounted: function mounted() {var self = this;self.init();}, computed: { isdisabledFn: function isdisabledFn(item) {var self = this;console.log('item', item);if (self.addData.auditStatus === '1') {return true;} else {return false;}} }, methods: { init: function init() {var self = this;self.getData('/api/deviceModelProtocol', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, jump: function jump(url) {// this.$router.push({ path: url })
      window.open(url);}, resetFun: function resetFun() {// 重置
      this.searchData.auditStatus = '';this.searchData.deviceTypeCode = '';this.searchData.isEnabled = '';this.init();}, resetFun2: function resetFun2() {// 重置
      this.detailsearchData.name = '';this.detailsearchData.code = '';this.getdetail();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, searchFun2: function searchFun2() {// 搜索事件
      this.detailsearchData.page = 1;this.getdetail();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, handleSizeChange2: function handleSizeChange2(val) {// 分页条数
      this.detailsearchData.rows = val;this.detailsearchData.page = 1;this.getdetail();}, handleCurrentChange2: function handleCurrentChange2(val) {// 分页页码
      this.detailsearchData.page = val;this.getdetail();}, handleCheckChange: function handleCheckChange(val) {if (val) {this.handleShowProtocol = true;} else {this.addData.codeName = '';this.addData.codeNum = 0;}}, handleAffirmCode: function handleAffirmCode() {console.log('lll');var self = this;if (self.$refs.popProtocol) {console.log('11122');self.$refs.popProtocol.handleCheckCode();}}, handleSetProtocol: function handleSetProtocol(protocol, codeList) {var self = this;console.log('setkkkkkk', protocol, codeList);self.handleShowProtocol = false;self.addData.referProtocolId = protocol.id;self.addData.codeName = protocol.deviceTypeCode;self.addData.codeNum = codeList.length;self.addData.referFunctionCodes = codeList;}, handleCopy: function handleCopy(id) {var self = this;self.$confirm('确定复制该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(function () {var path = '/api/deviceModelProtocol/' + id + '/copy';self.postData(path, {}, function (res) {self.$message({ message: '复制成功!', type: 'success' });self.init();});}).catch(function () {});}, addFun: function addFun() {// 新增
      this.title = '新增';this.addData = JSON.parse(JSON.stringify(this.defaultData));this.newadd = true;}, closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();done();}, onSubmit: function onSubmit() {var self = this;self.$refs.addForm.validate(function (valid) {if (valid) {self.postData('/api/deviceModelProtocolV1', self.addData, function (res) {self.$message({ message: '添加成功!', type: 'success' });self.init();self.onCencal();self.searchData.page = 1;});} else {return false;}});}, onCencal: function onCencal() {this.newadd = false;this.$refs['addForm'].resetFields();if (this.$refs['jsonFile']) {this.$refs['jsonFile'].value = '';}}, zxpoponCencal: function zxpoponCencal() {this.typeadd = false;this.$refs['addForm'].resetFields();this.templateSelection = '';}, onCencal2: function onCencal2() {this.newadd2 = false;this.$refs['addForm'].resetFields();}, changeisForceFun: function changeisForceFun(val) {var self = this;if (val === '0') {self.searchData.auditStatus = '0';}if (val === '1') {self.searchData.auditStatus = '1';}if (val === '2') {self.searchData.auditStatus = '2';}}, changeisEnabledFun: function changeisEnabledFun(val) {var self = this;
      if (val === '0') {
        self.searchData.isEnabled = '0';
      }if (val === '1') {
        self.searchData.isEnabled = '1';
      }
    },
    examineFun: function examineFun(item) {
      this.title = '封存';
      var self = this;
      console.log('item', item);
      self.addData.id = item;
      self.newadd2 = true;
    },
    yesFun: function yesFun() {
      var self = this;
      console.log('id', self.addData.id);
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.audit = '1';
          self.postData('/api/deviceModelProtocol/' + self.addData.id + '/audit/' + self.addData.audit, {}, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal2();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    noFun: function noFun() {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.audit = '2';
          self.postData('/api/deviceModelProtocol/' + self.addData.id + '/audit/' + self.addData.audit, {}, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal2();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      this.title = '修改';
      var self = this;
      this.addData = {
        id: item.id,
        deviceTypeCode: item.deviceTypeCode,
        firmwareVersion: item.firmwareVersion,
        remark: item.remark };

      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/deviceModelProtocol/' + self.addData.id, self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    getTemplateRow: function getTemplateRow(index, row) {
      this.templateSelection = index;
      this.deviceTypeCode = row.code;
    },
    getdetail: function getdetail() {
      var self = this;
      self.getData('/api/faDeviceType', self.detailsearchData, function (res) {
        console.log(res);
        self.shortTemplateData = res.list;
        self.pageData2.page = res.pageNum;
        self.pageData2.total = res.total;
      });
    },
    zxpoponUpdate: function zxpoponUpdate() {
      var self = this;
      if (self.deviceTypeCode === '') {
        self.$message({
          message: '请选择产品型号!',
          type: 'warning' });

      } else {
        self.addData.deviceTypeCode = self.deviceTypeCode;
        self.typeadd = false;
      }
    },
    xzFun: function xzFun() {
      this.getdetail();
      this.deviceTypeCode = this.addData.deviceTypeCode;
      this.typeadd = true;
      this.deviceTypeCode = '';
      this.addData.deviceTypeCode = '';
    },
    auditFun: function auditFun(item) {
      var self = this;
      var isEnabled = '';
      if (item.isEnabled === 0) {
        isEnabled = '1';
      } else if (item.isEnabled === 1) {
        isEnabled = '0';
      }
      self.$confirm('确定修改该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.postData('/api/deviceModelProtocol/' + item.id + '/enable/' + isEnabled, {}, function (res) {
          self.$message({
            message: '修改成功!',
            type: 'success' });

          self.init();
        });
      }).catch(function () {});
    },
    fileFun: function fileFun() {
      this.title = '用Json新增';
      this.newadd = true;
    },
    getFile: function getFile(event) {
      this.addData.jsonFile = event.target.files[0];
    },
    onImport: function onImport(event) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          var File = new FormData();
          File.append('jsonFile', self.addData.jsonFile);
          self.postData('/api/deviceModelProtocol/jsonImport', File, function (res) {
            self.$message({
              message: '导入成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    detailFun: function detailFun(item) {
      //				console.log(item)
      this.$router.push({
        path: 'agreementdetails', // 跳转路由
        query: { // 参数对象
          id: item.id,
          auditStatus: item.auditStatus,
          deviceTypeCode: item.deviceTypeCode } });


    } } };exports.default = _default;